(() => {
  const normalize = (str) =>
    (str || "").toString().trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const keywordsPersonalizar = ["personalizar", "personalize agora", "sim", "quero"];

  function updateVisibility() {
    const wrappers = document.querySelectorAll('[data-personalizacao-wrapper]');
    
    wrappers.forEach(wrapper => {
      const radios = document.querySelectorAll('input[type="radio"]:checked');
      let mostrarCampos = false;

      radios.forEach(radio => {
        const val = normalize(radio.value);
        if (keywordsPersonalizar.some(k => val.includes(k))) {
          mostrarCampos = true;
        }
      });

      const nomeInput = wrapper.querySelector('input[name="properties[Nome]"]');
      const numeroInput = wrapper.querySelector('input[name="properties[Número]"]');

      if (mostrarCampos) {
        wrapper.classList.remove("hidden");
        wrapper.style.display = "block";
        if (nomeInput) nomeInput.disabled = false;
        if (numeroInput) numeroInput.disabled = false;
      } else {
        wrapper.classList.add("hidden");
        wrapper.style.display = "none";
        if (nomeInput) { nomeInput.value = ""; nomeInput.disabled = true; }
        if (numeroInput) { numeroInput.value = ""; numeroInput.disabled = true; }
      }
    });
  }

  // --- O SEGREDO PARA PARAR DE PISCAR ---
  // Criamos um observador que detecta quando o Dawn troca o conteúdo da página
  const observer = new MutationObserver((mutations) => {
    updateVisibility();
  });

  // Começa a observar o corpo da página ou o formulário de produto
  const productInfo = document.querySelector('product-info') || document.body;
  observer.observe(productInfo, { childList: true, subtree: true });
  // --------------------------------------

  // Mantemos seus eventos originais por segurança
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"]')) {
       updateVisibility();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateVisibility);
  } else {
    updateVisibility();
  }

  // Bloqueios de renderização ao digitar (seus originais)
  document.addEventListener('change', (event) => {
    if (event.target.hasAttribute('data-no-render')) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('input', (event) => {
    if (event.target.hasAttribute('data-no-render')) {
      event.stopImmediatePropagation();
    }
  }, true);
})();